let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("tafv0")).then(() => parcelRequire('izRDD'));